'use client';

import dynamic from 'next/dynamic';
import type { ReactNode } from 'react';
import { isDevelopmentRuntime } from '@/lib/runtime-flags';
import { TrpcProvider } from '@/lib/trpc/provider';

const ReactQueryDevtools = dynamic(
  () => import('@tanstack/react-query-devtools').then((mod) => mod.ReactQueryDevtools),
  { ssr: false }
);

export function QueryProvider({ children }: { children: ReactNode }) {
  return (
    <TrpcProvider>
      {children}
      {isDevelopmentRuntime ? <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" /> : null}
    </TrpcProvider>
  );
}
